import { _js } from '@ifixit/localize';
import * as React from 'react';
import styled from 'styled-components';
import { DropdownContainer, CardColumn } from '../../dropdowns/card_dropdown_parts';
import StoreCard from './store_card';
import { space } from '@core-ds/primitives';
import trackInMatomoAndGA from 'Shared/Analytics/CombinedGAMatomo';

declare const Request: any;
// @ts-expect-error ts-migrate(7005) FIXME: Variable 'App' implicitly has an 'any' type.
declare const App;

const StyledDropdownContainer = styled(DropdownContainer)<{ mobile: boolean }>`
   padding-top: ${({ mobile }) => (mobile ? space[3] : space[2])};
   padding-bottom: ${space[3]};
`;

const updateStorePreference = (storePreference: any, currentStore: any) => {
   new Request.API_2_0('store/user/store_preference', {
      method: 'POST',
      onSuccess: () => {
         trackInMatomoAndGA({
            eventCategory: 'Preferred Store',
            eventAction: `Preferred Store - ${currentStore.storeCode} - ${storePreference.storeCode}`,
         });
         if (App.storeRedirectLinks && App.storeRedirectLinks[storePreference.storeCode]) {
            window.location = App.storeRedirectLinks[storePreference.storeCode];
         } else if (App.onStorePage && App.storeUrls) {
            window.location = App.storeUrls[storePreference.storeCode];
         } else {
            window.location.reload();
         }
      },
      statusPanelMessage: _js('Submitting'),
   }).send({
      newStore: storePreference.storeCode,
   });
};

// @ts-expect-error ts-migrate(7031) FIXME: Binding element 'stores' implicitly has an 'any' t... Remove this comment to see the full error message
const StoreDropdown = ({ stores, mobile = undefined, currentStore }) => {
   return (
      <StyledDropdownContainer id="storeDropdown" mobile={mobile}>
         <CardColumn>
            {stores.map((store: any) => (
               <StoreCard
                  key={store.name}
                  store={store}
                  mobile={mobile}
                  isDisplayStore={store.isDisplayStore}
                  updateStorePreference={() => {
                     updateStorePreference(store, currentStore);
                  }}
               />
            ))}
         </CardColumn>
      </StyledDropdownContainer>
   );
};

export default StoreDropdown;
